import { useTranslation } from "react-i18next";
import { FURNITURE_CATEGORIES } from "../../data/furniture";
import { cn } from "../../ui/cn";


export type FurnitureShopCategoryType = "all" | typeof FURNITURE_CATEGORIES[number];

interface FurnitureShopCategoryPillsProps {
  selectedCategory: FurnitureShopCategoryType;
  availableCategories: string[];
  categoryNamesMap: Record<string, string>;
  onSelectCategory: (category: FurnitureShopCategoryType) => void;
}

export default function FurnitureShopCategoryPills({
  selectedCategory,
  availableCategories,
  categoryNamesMap,
  onSelectCategory,
}: FurnitureShopCategoryPillsProps) {
  const { t } = useTranslation();

  return (
    <div className="bg-fullscreen-surface px-2xl pt-xl pb-md">
      <div className="flex flex-nowrap items-center gap-md overflow-x-scroll overflow-y-hidden [direction:ltr] pb-sm [scrollbar-color:var(--color-brand-alpha-85)_var(--color-white-alpha-12)] [scrollbar-gutter:stable] [scrollbar-width:thin]">
        {/* "All" category pill */}
        <button
          onClick={() => onSelectCategory("all")}
          className={cn(
            "shrink-0 cursor-pointer rounded-[20px] border-none px-xl py-md [font-family:Lato,sans-serif] text-[14px] font-bold whitespace-nowrap text-white",
            selectedCategory === "all"
              ? "bg-brand-alpha-85"
              : "bg-white-alpha-12",
          )}
        >
          {t("All furniture")}
        </button>

        {/* Category pills */}
        {availableCategories.map((category) => {
          const isSelected = selectedCategory === category;
          return (
            <button
              key={category}
              onClick={() => onSelectCategory(category as FurnitureShopCategoryType)}
              className={cn(
                "shrink-0 cursor-pointer rounded-[20px] border-none px-xl py-md [font-family:Lato,sans-serif] text-[14px] font-bold whitespace-nowrap text-white",
                isSelected
                  ? "bg-brand-alpha-85"
                  : "bg-white-alpha-12",
              )}
            >
              {categoryNamesMap[category as keyof typeof categoryNamesMap] || category}
              {/* Extract category keys for i18next-parser (static t() calls, never rendered) */}
              {/* eslint-disable-next-line no-constant-binary-expression -- dead branch keeps keys visible to i18next-parser */}
              {false && (
                <>
                  {t("Beds")}
                  {t("Rugs")}
                  {t("Nightstands")}
                  {t("Large Wardrobes")}
                  {t("Windows")}
                  {t("Paintings")}
                  {t("Dining Tables")}
                  {t("Dining Chairs")}
                </>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
